import { render, staticRenderFns } from "./LmContentTemplates.vue?vue&type=template&id=6afb957c"
import script from "./LmContentTemplates.vue?vue&type=script&lang=js"
export * from "./LmContentTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports